import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M10.904 2.042a3.532 3.532 0 0 0-3.673 4.96.67.67 0 0 1-.137.753l-4.843 4.843a.814.814 0 1 0 1.151 1.151l4.843-4.843A.67.67 0 0 1 9 8.769a3.533 3.533 0 0 0 4.96-3.673L12.114 6.94a1.374 1.374 0 0 1-1.923 0l-.005-.004L9.06 5.808a1.374 1.374 0 0 1 0-1.923l.004-.005zM9.575.746a4.88 4.88 0 0 1 2.886.355.673.673 0 0 1 .198 1.088l-2.638 2.639a.03.03 0 0 0 0 .038l1.113 1.113a.03.03 0 0 0 .038 0l2.639-2.638a.673.673 0 0 1 1.088.198 4.88 4.88 0 0 1-6.014 6.63l-4.531 4.532a2.16 2.16 0 1 1-3.055-3.055l4.532-4.531A4.878 4.878 0 0 1 9.575.745",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })